import { render, staticRenderFns } from "./GroupFormModal.vue?vue&type=template&id=127f2c11&"
import script from "./GroupFormModal.vue?vue&type=script&lang=js&"
export * from "./GroupFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports